module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_Overview-Middle_1.af85ec09.jpg";